// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"styles_hamburger__sRWE9","active":"styles_active__vNXjw"};